function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 3 Copy");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Subscriber-Shopping-Cart-Loyalty-Point",
  transform: "translate(-1183.000000, -389.000000)",
  fill: "#EAECF0",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(1017.000000, 240.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Payment"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(20.000000, 132.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3-Copy",
  transform: "translate(146.000000, 17.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ios-arrow-round-forward"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.56582147,0.191468819 C9.3001042,0.451866412 9.3001042,0.884126417 9.56061132,1.14973196 L12.7283779,4.32137465 L0.672108371,4.32137465 C0.30218826,4.32137465 0,4.62343586 0,4.99840839 C0,5.37338093 0.30218826,5.67544213 0.672108371,5.67544213 L12.7231678,5.67544213 L9.55540118,8.84708482 C9.29489406,9.11269037 9.3001042,9.53974242 9.56061132,9.80534796 C9.82632859,10.0657456 10.2483501,10.0657456 10.5140674,9.80014001 L14.8072247,5.47753996 C14.8645363,5.41504454 14.9114276,5.34734117 14.9478986,5.26401394 C14.9843696,5.18068671 15,5.09215153 15,5.00361634 C15,4.82654598 14.9322681,4.65989152 14.8072247,4.52969272 L10.5140674,0.207092674 C10.2587704,-0.0637208228 9.83153873,-0.0689287747 9.56582147,0.191468819 L9.56582147,0.191468819 Z",
  id: "Path"
}))))))));

var SvgBuyNowArrowIcon = function SvgBuyNowArrowIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "15px",
    height: "10px",
    viewBox: "0 0 15 10",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBuyNowArrowIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/buy-now-arrow-icon.6e4370b3.svg";
export { ForwardRef as ReactComponent };